import AllRoutes from './AllRoutes/AllRoutes';
import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Payment from './Pages/Payment';

function App() {
  return (
    <>
      <AllRoutes />
      {/* <Payment/> */}
    </>
  );
}

export default App;
